<script setup>
import { ref, watch } from 'vue';
import AttributeDateTimeInput from 'dashboard/components-next/CustomAttributes/AttributeDateTimeInput.vue';

const props = defineProps({
  attribute: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['update']);

const toDate = value => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const dateValue = ref(toDate(props.attribute.value));

watch(
  () => props.attribute.value,
  value => {
    dateValue.value = toDate(value);
  }
);

watch(dateValue, value => {
  emit('update', value ? value.toISOString() : '');
});
</script>

<template>
  <div class="flex flex-col w-full gap-1">
    <span class="mb-0.5 text-heading-3 text-n-slate-12">
      {{ attribute.attributeDisplayName }}
    </span>
    <AttributeDateTimeInput
      v-model="dateValue"
      :placeholder="attribute.placeholder || attribute.attributeDisplayName"
    />
  </div>
</template>
